import { render, staticRenderFns } from "./EocVitalsV1.vue?vue&type=template&id=1ef7544c&"
import script from "./EocVitalsV1.vue?vue&type=script&lang=js&"
export * from "./EocVitalsV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports